const getters = {
    starMapDetail: state => state.starMapDetail,
    mipApiList: state => state.mipApiList,
}

export default getters
